export default {
    PtSelectMenu: {
        deselect: '取消全部勾選',
        selected: '條已勾選',
    },
};
